<template>
  <div class="multi-select">
    <div class="selected-items">
      <span
        v-for="(item, index) in selectedItems"
        :key="index"
        class="badge bg-primary me-1"
      >
        <span class="item">{{ item.name }}</span>
        <button
          type="button"
          class="btn-close btn-close-white ms-1"
          aria-label="Remove"
          @click="removeItem(item.id)"
        ></button>
      </span>
    </div>
    <input
      type="text"
      class="form-control form-control-sm"
      v-model="search"
      placeholder="Buscar..."
      @focus="showDropdown = true"
      @input="filterOptions"
    />
    <ul v-if="showDropdown" class="dropdown-menu show">
      <li
        v-for="option in filteredOptions"
        :key="option.id"
        class="dropdown-item"
        @click="selectItem(option)"
      >
        {{ option.name }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "MultiSelect",
  props: {
    options: {
      type: Array,
      required: true,
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      search: "",
      showDropdown: false,
      filteredOptions: [],
    };
  },
  computed: {
    selectedItems() {
      return this.value.map((id) =>
        this.options.find((option) => option.id === id)
      );
    },
  },
  methods: {
    filterOptions() {
      const searchLower = this.search.toLowerCase();
      this.filteredOptions = this.options.filter(
        (option) =>
          option.name.toLowerCase().includes(searchLower) &&
          !this.value.includes(option.id)
      );
    },
    selectItem(option) {
      this.$emit("input", [...this.value, option.id]);
      this.search = "";
      this.showDropdown = false;
    },
    removeItem(id) {
      this.$emit("input", this.value.filter((item) => item !== id));
    },
  },
  watch: {
    options: {
      immediate: true,
      handler() {
        this.filteredOptions = this.options;
      },
    },
  },
};
</script>

<style scoped>
.multi-select {
  position: relative;
}
.selected-items {
  margin-bottom: 0.5rem;
}
.dropdown-menu {
  max-height: 200px;
  overflow-y: auto;
  width: 100%;
}
.item {
  position: relative;
  top: 4px;
}
</style>